import { NavLink, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./ViewCode.css"
import { useEffect } from "react";
import { loadCodeActions } from "../store/leaderboard";


export default function ViewCode(){
    const {userId} = useParams();
    const {code} = useSelector(
        (state) => state.myLeaderboard
      );
    
    const {loading} = useSelector(s => s.myLeaderboard.showCodeState)

    const dispatch = useDispatch();

    useEffect(()=>{
      dispatch(loadCodeActions(userId));
    }, [])

    if(loading){
      return <p>Loading.....</p>
    }
    
    return <div className="container">
              <div className="code-container">
                  <pre>
                    <code>
                      {code.split('\n').map((line, index) => {
                        const hashIndex = line.indexOf('#');
                        if (hashIndex !== -1) {
                          return (
                            <span key={index}>
                              {line.slice(0, hashIndex)}
                              <span className="comment-inline">{line.slice(hashIndex)}</span>
                              <br />
                            </span>
                          );
                        }
                        return (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        );
                      })}
                    </code>
                  </pre>
              </div>
              <NavLink to="/" className="navlink-button">LeaderBoard</NavLink>
            </div>
          
}